import React from 'react';

const LayoutWrapper = ({ children, title, subtitle, actions }) => {
  return (
    <div className="min-h-screen overflow-x-hidden overflow-y-auto scrollbar-hide bg-gray-100">
      <div className="p-4 sm:p-6">
        {(title || actions) && (
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
            <div className="min-w-0">
              {title && (
                <h1 className="text-2xl font-semibold text-gray-900 truncate">
                  {title}
                </h1>
              )}
              {subtitle && (
                <p className="text-sm text-gray-500 mt-1">
                  {subtitle}
                </p>
              )}
            </div>
            {actions && (
              <div className="flex items-center gap-2 flex-wrap">
                {actions}
              </div>
            )}
          </div>
        )}

        <div className="bg-white rounded-xl border border-gray-200 p-4 sm:p-6">
          {children}
        </div>
      </div>
    </div>
  );
};

export default LayoutWrapper;
